

import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useLocation } from "react-router-dom"
import styled from "styled-components"
import Btn from "../../shared/button/Btn"
import { showModal } from "../../../features/modal/modalSlice"
import { useScrollLock } from "../../../hooks/useScrollLock"
import PageTopTitle from "../../shared/PageTopTitle"
import SmallSpinner from "../../shared/spinners/SmallSpinner"
import Button from "../../shared/Button"
import { getSigortaBanner, setUpdateSigortaDoc, updateSigortaBanner } from "../../../features/sigorta/sigortaSlice"
import { validateFile } from "../../../helper/docs/validateFile"

const ModalContainer = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: 1000px;
        height: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        border: 1px solid ${({ theme }) => theme.mainBorderColor};
        padding-top: 20px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;

        .content{
            margin: 40px;
            width: auto;
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 40px;
            border-radius: 20px;
            width: 100%;

            .top-container{
              display: flex;
              justify-content: space-between;
              align-items: center;
              gap: 10px;
              border-radius: 15px;

              .file-input-label{
                background-color: var(--color-main);
                color: #fff;
                border-radius: 10px;
                width: 220px;
                height: 40px;
                display: flex;
                justify-content: center;
                align-items: center;
                cursor: pointer;
              }


              .file-input{
                display: none;
              }
            }


            .doc-container{
              display: flex;
              justify-content: center;
              gap: 10px;
              width: 100%;


              .doc-item{
                width: calc(50% - 20px);
                display: flex;
                flex-direction: column;
                align-items: center;
                border: 1px solid ${({ theme }) => theme.mainBorderColor};
                padding: 15px;
                border-radius: 10px;
                height: auto;

                .doc-item-title{
                  font-size: var(--font-size-md);
                  font-weight: var(--font-weight-lg);
                  margin-bottom: 10px;
                  border-radius: 5px;
                }
                
                img{
                  width: 100%;
                  height: auto;
                  object-fit: cover !important;
                }

                .doc-bottom{
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  width: 100%;
                  border-top: 1px solid ${({ theme }) => theme.mainBorderColor};
                  padding-top: 10px;


                  .file-name{
                    font-size: var(--font-size-sm);
                    font-weight: var(--font-weight-lg);
                  }

                }
              }

              .active{
                border-color: var(--color-main);
              }
            }

            .btn-container{
              width: 100%;
              display: flex;
              justify-content: center;
            }
          }
        }

`
const SigortaReklamGörselModal = () => {

    const location = useLocation()
    const dispatch = useDispatch()

    const {modalLocation } = useSelector(state => state.modal)
    const {sigortaBanner, isLoadingUpdateSigortaBanner, updateSigortaDoc} = useSelector(state => state.sigorta)

    const { lockScroll, unlockScroll } = useScrollLock();


    useEffect(() => {
        dispatch(getSigortaBanner())
    },[])


    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])

    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])

    const handleSubmit = () => {
      if(updateSigortaDoc){
        dispatch(updateSigortaBanner(updateSigortaDoc))
      }
    }

    const handleFileChange = async(e) => {

      const file = await validateFile({file: e.target.files[0], maxSize: 5 * 1024 * 1024, allowedTypes:['image/jpeg', 'image/jpg', 'image/png', 'application/pdf']})

      if(file){
        dispatch(setUpdateSigortaDoc(e.target.files[0]))
      }

    }

  return (
    <ModalContainer>
    <div className="modal" onClick={(e) => e.stopPropagation()}>
        <PageTopTitle title={"Sigorta Reklam Görseli"}/>
        <div className="content">

          <div className="top-container">
              <label className="file-input-label" htmlFor="kimlikFile">Dosya Seç</label>
              <input type="file" id="kimlikFile" className='file-input' onChange={handleFileChange} />
          </div>

          <div className="doc-container">

            {
              sigortaBanner &&
              <div className="doc-item">
                <div className="doc-item-title">Mevcut Gösterilen Sigorta Görseli</div>
                <img src={`${process.env.REACT_APP_API_IMG_URI}${sigortaBanner}`} alt="current-sigorta" />
              </div>
            }

            {
              updateSigortaDoc &&
              <div className="doc-item active">
                  <div className="doc-item-title">Yeni Güncellenecek Sigorta Görseli</div>
                  <img src={ URL.createObjectURL(updateSigortaDoc)} alt="new-sigorta" />
                  <div className="doc-bottom">
                    <Btn bgColor="#E85446" handleClick={handleSubmit} width={"180px"}>{isLoadingUpdateSigortaBanner ? <SmallSpinner size={"20px"} color={"#fff"} bgColor={"#fff"}/>: "Kaydet"}</Btn>
                    <span className="file-name">{updateSigortaDoc?.name}</span>
                  </div>
              </div>
            }

          </div>
            <div className="btn-container">
              <Btn color={"#E85446"} bgColor={"transparent"} borderColor="#E85446" width="220px" radius={"10px"} handleClick={()=> dispatch(showModal(null))}>Kapat</Btn>
            </div>
        </div>
    </div>
</ModalContainer>
  )
}

export default SigortaReklamGörselModal